'use client';

import { FC, PropsWithChildren } from 'react';
import { ROOT_PORTALS } from 'constants/targets';
import { Portal, Drawer } from 'components/pcc-components';
import { useStoreInfoDrawer } from './store-info-drawer-context';

export const StoreInfoDrawerWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { drawerProps } = useStoreInfoDrawer();

  return (
    <Portal id={ROOT_PORTALS}>
      <Drawer {...drawerProps}>{children}</Drawer>
    </Portal>
  );
};
